<template>
  <div class="finance-page main-wrapper history-page">
    <div class="finance-page__inner px-2 px-md-3 pt-2">
      <h3 class="finance-page__title">
        {{ $t('transaction.transactions') }}
      </h3>

      <div class="finance-panel history-toolbar">
        <div
          class="history-type-pills"
          role="group"
          :aria-label="$t('transaction.transactions')"
        >
          <button
            type="button"
            class="history-pill"
            :class="{ 'history-pill--active': transactionType === 'all' }"
            @click="fetchHistory('all')"
          >
            {{ $t('transaction.all') }}
          </button>
          <button
            type="button"
            class="history-pill"
            :class="{ 'history-pill--active': transactionType === 'in' }"
            @click="fetchHistory('in')"
          >
            {{ $t('transaction.deposit') }}
          </button>
          <button
            type="button"
            class="history-pill"
            :class="{ 'history-pill--active': transactionType === 'out' }"
            @click="fetchHistory('out')"
          >
            {{ $t('transaction.withdraw') }}
          </button>
        </div>
        <div class="history-date-row">
          <div class="history-date-select transaction">
            <label class="finance-label history-date-label">{{ $t('football.date') }}</label>
            <v-select
              v-model="params.date"
              :reduce="(draw) => draw.data"
              label="label"
              :options="dateOptions"
            />
          </div>
          <button
            type="button"
            class="btn finance-btn-primary history-search-btn"
            @click="fetchHistory(transactionType)"
          >
            {{ $t('transaction.search') }}
          </button>
        </div>
      </div>

      <div class="finance-panel history-table-panel mt-3">
        <div
          v-if="isLoading"
          class="history-loading"
        >
          <Loading
            color="#16a34a"
            size="24"
            class="px-4 py-0"
          />
          <span class="history-loading-text">{{ $t('please_wait') }}</span>
        </div>
        <template v-else>
          <div class="history-table-scroll">
            <DataTable
              :table-data="tableData"
              @getSlipData="fetchSlipData"
            />
          </div>
          <div class="history-pagination-wrap">
            <van-pagination
              v-model="currentPage"
              :total-items="rows"
              :items-per-page="10"
              :show-page-size="3"
              size="sm"
              force-ellipses
            >
              <template #prev-text>
                <van-icon name="arrow-left" />
              </template>
              <template #next-text>
                <van-icon name="arrow" />
              </template>
              <template #page="{ text }">{{ text }}</template>
            </van-pagination>
          </div>
        </template>
      </div>
    </div>

    <div
      id="voucher-history"
      class="modal fade history-voucher-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content history-voucher-modal__content">
          <div
            class="text-center modal-cross history-modal-cross"
            @click="closeModal"
          >
            X
          </div>
          <div class="modal-body p-0">
            <FBVoucher
              :type="type"
              :datas="datas"
              :slip-id="slipId"
              :current-time="bet_date"
              :is-history="true"
              :is_result="is_result"
              :bingo_amount="bingo_amount"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DateTime } from 'luxon';
import { Loading } from 'vant';
import DataTable from './components/DataTable.vue';
import FBVoucher from './components/FBVoucher.vue';
import { mapActions } from 'vuex';

export default {
  components: { DataTable, FBVoucher, Loading },
  data() {
    return {
      tableData: {
        headings: [this.$t('transaction.status'), this.$t('voucher.total_amount'), this.$t('transaction.balance'), this.$t('transaction.type'), this.$t('transaction.action_by'), this.$t('voucher.bet_date')],
        datas: [],
      },
      rows: 1,
      currentPage: 1,
      depositActive: false,
      withdrawActive: false,
      transactionType: 'all',
      params: {
        draw: '',
        date: '',
      },
      dateOptions: [],
      type: 'maung',
      datas: [],
      slipId: null,
      bet_date: null,
      bingo_amount: null,
      is_result: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format('l');
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    closeModal() {
      $('#voucher-history').modal('hide');
    },
    fetchSlipData(data) {
      this.type = data.type;
      this.datas = data.team_vouchers;
      this.bingo_amount = data.bingo_amount;
      this.slipId = data.voucher_id;
      this.is_result = data.isBet;
      this.bet_date = this.betTime(data.created_at);
      $('#voucher-history').modal('show');
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    async fetchHistory(type = 'all') {
      try {
        this.transactionType = type;
        this.isLoading = true;
        this.tableData.contents = [
          'status',
          'amount',
          'current_amount',
          'type',
          'by_user_name',
          'created_at',
        ];
        const res = await axios.post('/transactions/get_by_solo', {
          page: this.currentPage,
          limit: 10,
          user_id: this.$store.state.authUser.id,
          drawDate: this.params.date,
          type,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.tableData.datas = res.data.data;
        for (let index = 0; index < this.tableData.datas.length; index += 1) {
          this.tableData.datas[index].created_at = this.betTime(this.tableData.datas[index].created_at);
          this.tableData.datas[index].amount = Number(this.tableData.datas[index].amount).toLocaleString();
          this.tableData.datas[index].current_amount = Number(this.tableData.datas[index].current_amount).toLocaleString();
        }
        this.isLoading = false;
        this.rows = res.data.total;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  watch: {
    currentPage() {
      this.fetchHistory(this.transactionType);
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    await this.fetchHistory();
    this.setOneMonth();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    this.params.date = moment(new Date()).format('l');
  },
};
</script>
<style scoped>
/* Stack above .history-table-panel so vue-select dropdown is not covered (both panels use backdrop-filter) */
.history-toolbar {
  position: relative;
  z-index: 50;
  padding-bottom: 1rem;
  overflow: visible;
}

.history-table-panel {
  position: relative;
  z-index: 1;
  padding: 0.75rem 0.5rem 1rem;
}

.history-date-select {
  position: relative;
  z-index: 2;
  flex: 1 1 200px;
  min-width: 0;
  overflow: visible;
}

.history-date-select ::v-deep .vs__dropdown-menu {
  z-index: 2000 !important;
}

.history-date-select ::v-deep .vs--open {
  z-index: 2001;
}

.history-type-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.history-pill {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.45rem 0.65rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #334155;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  -webkit-tap-highlight-color: transparent;
}

.history-pill--active {
  border-color: transparent;
  color: #fff !important;
  background: linear-gradient(135deg, #0d5c2e 0%, #16a34a 100%);
}

.history-date-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.history-date-label {
  margin-bottom: 6px;
  font-size: 0.75rem;
}

.history-search-btn {
  flex: 0 0 auto;
  width: auto !important;
  min-width: 5.5rem;
  min-height: 44px;
  margin-top: 0 !important;
  align-self: flex-end;
}

.history-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 2.5rem 1rem;
}

.history-loading-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
}

.history-table-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 12px;
}

.history-pagination-wrap {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}

.history-pagination-wrap ::v-deep .van-pagination__item {
  color: #0d5c2e;
}

.history-pagination-wrap ::v-deep .van-pagination__item--active {
  background: linear-gradient(135deg, #0d5c2e 0%, #16a34a 100%);
  border-color: transparent;
  color: #fff;
}

.history-voucher-modal__content {
  border: none;
  border-radius: 16px;
  overflow: hidden;
}

.history-modal-cross {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  padding-top: 4px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: 8px;
  margin-top: 8px;
  background: linear-gradient(135deg, #166534 0%, #16a34a 100%);
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
}

@media (max-width: 768px) {
  .main-wrapper {
    padding: 0 !important;
  }

  .history-search-btn {
    width: 100% !important;
    align-self: stretch;
  }
}
</style>
